import React, { Component } from "react";
import {
  Checkbox,
  Div,
  I,
  If,
  Image,
  InputGroup,
  Label,
  ModalNotification,
  Title
} from "../../components";
import { Color, Http, Mask, Routes, Type, Utils } from "../../utilities";
import CarrinhoUtils from "../utils/CarrinhoUtils";

const styles = {
  lista: {
    height: 50,
    border: `1px solid ${Color.ECOMMERCE.CINZA}`,
    margin: 5,
    color: Color.ECOMMERCE.CINZA,
  },
  containerAddItem: {
    backgroundColor: "#f2f2f2",
    borderRadius: 10,
    lineHeight: "10px",
  },
  labelSubTotalItem: {
    fontSize: 25,
    color: Color.ECOMMERCE.LARANJA,
    marginTop: 10,
    marginRight: 15,
  },
  textoRiscado: {
    textDecoration: "line-through",
  },
  menuDrop: {
    width: "100%",
  },
  menuDropAtivo: {
    backgroundColor: "var(--cor-primaria)",
    color: "#fff",
  },
  assinaturaAtiva: {
    backgroundColor: Color.EMPRESA.PRIMARIA,
    color: Color.ECOMMERCE.WHITE,
  },
};

class ListaCompra extends Component {
  constructor(props) {
    super(props);

    this.state = {
      corPrimaria: "var(--cor-primaria)",
      listaAlterada: false,
      listas: [],
      produtosPesquisa: [],
      listaSelecionada: {},
    }
  }

  getQuantidadeLabel(produto) {
    let preco = produto.precoVenda;
    let quantidade = produto.quantidade || 0;
    return produto.possuiQuantidadeFracionada
      ? `${Number(produto.quantidade)}g`
      : `${quantidade}un x ${Mask.formatValueBr(preco)}`;
  }

  listarProdutosPesquisa() {
    Http.get(`/busca/${this.state.textoPesquisa}`)
      .then(({ status, data }) => {
        if (status) {
          this.setState(
            {
              produtosPesquisa: data.listaProdutos,
              sucessoPesquisa: data.sucessoPesquisa,
            },
            () => this.renderPesquisarProdutos()
          );
        }
      })
      .catch((error) => console.log(error));
  }

  atualizarProdutoLista(produto) {
    // Http.put("/listacompra/produto", produto)
    //   .then(({ status, data }) => {
    //     if (status) {
    //       if (data.status) {
    //         this.forceUpdate();
    //       } else {
    //         ModalNotification.renderMessage({
    //           title: "Ocorreu um erro ao atualizar a lista",
    //           body: "Falha ao atualizar produto da lista",
    //           handlerCancel: () => { },
    //           labelButtonCancel: "Fechar",
    //         });
    //       }
    //     }
    //   })
    //   .catch((erro) => {
    //     console.log(erro);
    //   });
  }

  deletarProdutoLista(produto) {
    console.log(produto);
    // Http.delete("/listacompra/produto", produto)
    //   .then(({ status, data }) => {
    //     if (status) {
    //       if (data.status) {
    //         this.consultarListasDeCompra();
    //       } else {
    //         ModalNotification.renderMessage({
    //           title: "Ocorreu um erro ao atualizar a lista",
    //           body: "Falha ao atualizar produto da lista",
    //           handlerCancel: () => { },
    //           labelButtonCancel: "Fechar",
    //         });
    //       }
    //     }
    //   })
    //   .catch((erro) => {
    //     console.log(erro);
    //   });
  }

  deletarListaCompra(lista) {
    // Http.delete("/listacompra", lista)
    //   .then(({ status, data }) => {
    //     if (status) {
    //       if (data.status) {
    //         this.consultarListasDeCompra();
    //       } else {
    //         ModalNotification.renderMessage({
    //           title: "Ocorreu um erro ao remover a lista",
    //           body: "Falha ao remover a lista",
    //           handlerCancel: () => { },
    //           labelButtonCancel: "Fechar",
    //         });
    //       }
    //     }
    //   })
    //   .catch((erro) => {
    //     console.log(erro);
    //   });
  }

  getProdutosSelecionados() {
    let itens = [];
    let produtosSelecionadosPesquisa = new Map(
      this.state.produtosSelecionadosPesquisa
    );
    produtosSelecionadosPesquisa.forEach((p) => itens.push(p));
    return itens;
  }

  colocarProdutosNoCarrinho() {
    let itens = JSON.parse(JSON.stringify(this.state.listaSelecionada.itens));
    if (Utils.isValueValid(itens)) {
      Array.from(itens).forEach((item) => {
        CarrinhoUtils.addQuantidadeItemJaNoCarrinhoLista(this.props.carrinho, item);
        CarrinhoUtils.adicionarItemNoCarrinhoDeCompras(
          item,
          this.props.carrinho,
          this.props.atualizarCarrinho,
          null,
          this.state.parametrosPedido
        );
      });
      this.props.history.push(Routes.CARRINHO, {
        parametros: this.state.parametrosPedido,
        logoEmpresa: this.state.urlFotoEmpresa,
        empresa: this.state.empresa,
      });
    } else {
      ModalNotification.renderMessage({
        title: "Mensagem",
        body: (
          <Label value="Nenhum produto na lista para colocar no carrinho!" />
        ),
        handlerCancel: () => { },
        labelButtonCancel: "Fechar",
      });
    }
  }


  solicitarRemocaoProdutoLista(prod) {
    ModalNotification.renderMessage({
      title: "Remover produto da lista",
      body: `Deseja realmente remover o produto ${prod.descricao} da lista`,
      handlerCancel: () => { },
      handlerConfirm: () => this.deletarProdutoLista(prod),
    });
  }

  renderPesquisarProdutos() {
    let produtos = this.state.produtosPesquisa;
    let produtosSelecionadosPesquisa = new Map(
      this.state.produtosSelecionadosPesquisa
    );
  
    ModalNotification.renderMessage({
      title: "Selecione os produtos para adicionar na lista",
      responsive: "10",
      body: (
        <Div
          className="d-flex align-items-start justify-content-start align-self-start"
          style={{ width: "100%" }}
        >
          <Div
            col="5"
            className="border-left border-right"
            style={{ height: window.innerHeight / 1.8, overflow: "auto" }}
            column
          >
            <Label
              value="Produtos selecionados"
              family="Light"
              style={{ color: Color.ECOMMERCE.CINZA_ESCURO }}
            />
            <If and value1={produtosSelecionadosPesquisa.size === 0}>
              <Label
                value="Nenhum produto selecionado"
                family="Light"
                style={{ color: this.state.corPrimaria }}
              />
            </If>
            <If and value1={produtosSelecionadosPesquisa.size > 0}>
              {this.getProdutosSelecionados().map((produto, index) => {
                return (
                  <Div inline="between" key={index} className="border-bottom">
                    <Div inline="start" style={{ width: "100%" }}>
                      <Div col="4" column>
                        <Image
                          styleImage={{ width: 50, height: 50 }}
                          src={produto.urlImagemPrincipalThumbnail}
                        />
                        <Label
                          family="Light"
                          value={produto.descricao}
                          className="text-ellipsis"
                          style={{ width: 150 }}
                        />
                      </Div>
                      <Div
                        inline="center"
                        col="6"
                        style={styles.containerAddItem}
                      >
                        <I
                          icon={Type.ICON.MINUS}
                          pointer
                          style={{
                            color: this.state.corPrimaria,
                            fontSize: 20,
                          }}
                          handlerClick={() => {
                            if (
                              Utils.isValueValid(produto.quantidade) &&
                              produto.quantidade > 0
                            ) {
                              this.removeQuantidadeItemPesquisa(produto);
                            }
                          }}
                        />
                        <Label
                          value={this.getQuantidadeLabel(produto)}
                          family="Light"
                          margin="3"
                          className="mx-auto"
                        />
                        <I
                          icon={Type.ICON.PLUS}
                          pointer
                          style={{
                            color: this.state.corPrimaria,
                            fontSize: 20,
                          }}
                          handlerClick={() => {
                            this.addQuantidadeItemPesquisa(produto);
                          }}
                        />
                      </Div>
                      <Div col="2">
                        <Label
                          family="Light"
                          marginLeft="2"
                          style={{
                            color: this.state.corPrimaria,
                            fontSize: 15,
                          }}
                          value={Mask.formatValueBr(produto.valorSubTotalItem)}
                        />
                      </Div>
                    </Div>
                  </Div>
                );
              })}
            </If>
          </Div>
          <Div col="7">
            <InputGroup
              prepend={false}
              append
              placeholder="Nome do produto"
              value={this.state.textoPesquisa}
              icon={Type.ICON.SEARCH}
              label="Pesquise produtos para adicionar na lista"
              handlerChange={(e) => {
                this.setState(
                  { textoPesquisa: e.target.value, sucessoPesquisa: true },
                  () => this.renderPesquisarProdutos()
                );
              }}
              handlerKeyUp={(e) => {
                if (e.keyCode === 13) this.listarProdutosPesquisa();
              }}
              handlerIcon={() => this.listarProdutosPesquisa()}
            />
            <If and value1={!this.state.sucessoPesquisa}>
              <Label
                value={`Produto não encontrado para a pesquisa: '${this.state.textoPesquisa}'`}
                family="Light"
                style={{ color: this.state.corPrimaria }}
              />
            </If>
            <Div style={{ height: window.innerHeight / 2, overflow: "auto" }}>
              {Array.from(produtos).map((produto, index) => {
                return (
                  <Div inline="between" key={index} className="border-bottom">
                    <Div inline="start">
                      <Image
                        styleImage={{ width: 70, height: 70 }}
                        src={produto.urlImagemPrincipalThumbnail}
                      />
                      <Label
                        family="Light"
                        value={produto.descricao}
                        className="text-ellipsis"
                        style={{ width: 200 }}
                      />
                      <Label
                        family="Light"
                        marginLeft="2"
                        style={{ color: this.state.corPrimaria, fontSize: 20 }}
                        value={Mask.formatValueBr(produto.precoVenda)}
                      />
                    </Div>
                    <Checkbox
                      handlerChange={({ checked }) => {
                        if (checked) {
                          produtosSelecionadosPesquisa.set(
                            produto.codigoBarras,
                            produto
                          );
                        } else {
                          produtosSelecionadosPesquisa.delete(
                            produto.codigoBarras
                          );
                        }
                        this.setState({ produtosSelecionadosPesquisa }, () => {
                          if (checked) {
                            this.addQuantidadeInicialPesquisa(produto);
                          } else {
                            this.renderPesquisarProdutos();
                          }
                        });
                      }}
                      checked={Utils.isValueValid(
                        produtosSelecionadosPesquisa.get(produto.codigoBarras)
                      )}
                      marginLeft="3"
                    />
                  </Div>
                );
              })}
            </Div>
          </Div>
        </Div>
      ),
      handlerConfirm: () => {
        if (produtosSelecionadosPesquisa.size > 0) {
          this.atualizarListaCompra();
        } else {
          this.setState({
            produtosPesquisa: [],
            textoPesquisa: "",
          });
        }
      },
      handlerCancel: () => {
        this.setState({
          produtosSelecionadosPesquisa: new Map(),
          produtosPesquisa: [],
          textoPesquisa: "",
        });
      },
    });
  }


  renderProdutos = (lista) => {
    let { corPrimaria, listaAlterada } = this.state;
    let produtos = Array.from(this.props.itens || []);

    let totalItens = this.props.itens
      .map((p) => Number(p.precoVenda * p.quantidade))
      .reduce((a, b) => a + b, 0);

    let idParent = Utils.uuidString();

    return (
      <Div col="12" id={idParent} padding="2" shadow rounded className="border">
        <Div inline="between">
          <Title
            value="PRODUTOS DA LISTA"
            type="h6"
            family="Bold"
            style={{
              marginLeft: "1.3rem",
              marginBottom: "10px",
              color: Color.ECOMMERCE.CINZA_ESCURO
            }}
          />
          
        </Div>
        {/* <Div col="12" inline="between">
          <Div
            inline="center"
            className="border p-1 m-1"
            rounded
            pointer
            handlerClick={() => this.renderPesquisarProdutos()}
          >
            <I
              icon={Type.ICON.PLUS_SQUARE}
              pointer
              style={{ fontSize: 25, color: corPrimaria }}
            />
            <Label
              family="Light"
              value="Adicionar produto"
              pointer
              marginTop="2"
              marginLeft="2"
            />
          </Div>
        </Div> */}
        {this.props.itens.map((prod, index) => {
          let unidade = prod.possuiQuantidadeFracionada ? "KG" : "UN";
          return (
            <Div key={index}>
              <Div
                inline="between"
                padding="2"
                col="12"
                style={{ borderBottom: "1px solid #f2f2f2" }}
              >
                <Div inline="start" col="6">
                  <Image
                    border
                    src={prod.urlImagemPrincipalThumbnail}
                    width="70px"
                  />
                  <Label
                    className="text-ellipsis descricao-item"
                    value={prod.descricao}
                    marginLeft="2"
                    family="Light"
                    style={
                      prod.quantidade > 0
                        ? { width: "70%" }
                        : { width: "70%", ...styles.textoRiscado }
                    }
                  />
                </Div>
                <Div inline="center" col="3" style={styles.containerAddItem}>
                  {/* <I
                    icon={Type.ICON.MINUS}
                    pointer
                    style={{ color: corPrimaria, fontSize: 20 }}
                    handlerClick={() => {
                      if (prod.quantidade > 0) {
                        this.removeQuantidadeItemLista(lista, prod);

                        if (prod.quantidade === 0) {
                          this.deletarProdutoLista(prod);
                        }
                      }
                    }}
                  /> */}
                  <Label
                    value={this.getQuantidadeLabel(prod)}
                    family="Light"
                    margin="3"
                    className="mx-auto"
                  />
                  {/* <I
                    icon={Type.ICON.PLUS}
                    pointer
                    style={{ color: corPrimaria, fontSize: 20 }}
                    handlerClick={() => {
                      this.addQuantidadeItemLista(lista, prod);
                    }}
                  /> */}
                </Div>
                <Div col="3">
                  <Label
                    value={Mask.formatValueBr(Number(prod.precoVenda * prod.quantidade))}
                    col="1"
                    family="SemiBold"
                    style={{ ...styles.labelSubTotalItem, color: corPrimaria }}
                  />
                </Div>
                {/* <I
                  icon={Type.ICON.CLOSEX}
                  style={{ position: "absolute", right: 20, color: "red" }}
                  pointer
                  handlerClick={() => this.solicitarRemocaoProdutoLista(prod)}
                /> */}
              </Div>
            </Div>
          );
        })}
        <Div
          inline="between"
          style={{ width: "99%", backgroundColor: "#f2f2f2" }}
          margin="2"
          padding="2"
          shadow
          className="border"
          rounded
        >
          <Label
            value="Total da lista"
            style={{
              color: Color.ECOMMERCE.CINZA_ESCURO,

              fontSize: 20,
            }}
            family="Bold"
          />
          <Label
            value={Mask.formatValueBr(Number(totalItens))}
            style={{ color: Color.ECOMMERCE.CINZA_ESCURO, fontSize: 20 }}
            family="Bold"
          />
        </Div>
      </Div>
    );
  };

  render() {
    const { listaSelecionada } = this.state;
    console.log(this.props.itens)

    return (
      <Div col="12">
        <If and value1={Utils.isValueValid(listaSelecionada)}>
          <Div>{this.renderProdutos(listaSelecionada)}</Div>
        </If>
      </Div>
    )
  }
}

export default ListaCompra;
